<vl-title tag-name="span" tag-style="h6">{{ name }}
    <template v-if="identifier"> - {{ identifier }}</template>
</vl-title>
<vl-title v-if="vatNumber" tag-name="span" tag-style="h6">BTW {{ vatNumber }} </vl-title>